import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import classNames from 'classnames/bind';
import styles from './Common.module.scss';

const cx = classNames.bind(styles);

const antIcon = (
    <LoadingOutlined
        style={{
            fontSize: 24,
        }}
        spin
    />
);
function Loading() {
    return (
        <div className={cx('wrapper__loading')}>
            <Spin indicator={antIcon} />
        </div>
    );
}

export default Loading;
